var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.2301 6.36035H17.6701C18.0101 6.38035 18.2401 6.50035 18.3901 6.83035L18.4101 19.2204C18.2501 20.2704 17.4001 21.1104 16.3201 21.1904H5.6901C4.6101 21.0904 3.7001 20.2404 3.6001 19.1404V6.96035C3.6201 6.63035 3.9101 6.39035 4.2301 6.36035ZM17.0501 7.70035H4.9501V19.1004C4.9501 19.4604 5.5201 19.8804 5.8801 19.8404H16.2201C16.5101 19.8604 17.0401 19.4104 17.0401 19.1404V7.70035H17.0501Z",
    fill: "#223D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6501 4.00008H19.9301C19.9301 4.00008 20.1001 4.10008 20.1301 4.12008C20.6001 4.47008 20.4601 5.17008 19.9001 5.33008L2.23009 5.36008C1.60009 5.29008 1.35009 4.52008 1.87009 4.13008C1.90009 4.11008 2.06009 4.01008 2.07009 4.01008H6.35009V2.20008C6.35009 1.46008 7.11009 0.870078 7.80009 0.830078H14.3601C14.9401 0.880078 15.6601 1.58008 15.6601 2.16008V4.01008L15.6501 4.00008ZM7.74009 4.00008H14.2401L14.3001 3.94008V2.31008C14.3001 2.31008 14.2101 2.17008 14.2001 2.17008H7.80009L7.74009 2.23008V4.00008Z",
    fill: "#223D51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44018 9.53969C8.87018 9.44969 9.26018 9.69969 9.29018 10.1497V17.4697C9.14018 18.3197 8.01018 18.2697 7.93018 17.3897V10.1897C7.93018 9.92969 8.19018 9.58969 8.44018 9.53969Z",
    fill: "#223D51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2202 9.53997C13.6702 9.45997 14.0302 9.73997 14.0702 10.19V17.39C13.9802 18.22 12.7802 18.23 12.7102 17.39V10.11C12.7202 9.84997 12.9702 9.58997 13.2202 9.53997Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fae4c256d12b6dde2b321bcb35d32b1e.svg";
export { ForwardRef as ReactComponent };